import { requestRmaButtonsStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaButtons";
import { clearBtnStyle, removeBtnFocusBorder } from "@waytek/Utilities/styleguide/btnIcon";
import { css } from "styled-components";

requestRmaButtonsStyles.narrowOverflowMenu = {
    ...requestRmaButtonsStyles.narrowOverflowMenu,

    cssOverrides: {
        wrapper: css`
            button {
                ${clearBtnStyle}
                ${removeBtnFocusBorder}
            }
        `,
    },
};

requestRmaButtonsStyles.sendButton = {
    ...requestRmaButtonsStyles.sendButton,

    css: css`
        margin-left: 20px;
    `,
};
